import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagramRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			x: 4,
			y: 4,
			rx: 8,
			fill: "url(#instagramRegularPaint0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.334 11.916A2.916 2.916 0 0 1 11.25 9h8.748a2.916 2.916 0 0 1 2.916 2.916v8.748a2.916 2.916 0 0 1-2.916 2.916H11.25a2.916 2.916 0 0 1-2.916-2.916V11.916Zm2.916-1.458c-.805 0-1.458.653-1.458 1.458v8.748c0 .805.653 1.458 1.458 1.458h8.748c.805 0 1.458-.653 1.458-1.458V11.916c0-.805-.653-1.458-1.458-1.458H11.25ZM15.624 14.103a2.187 2.187 0 1 0 0 4.374 2.187 2.187 0 0 0 0-4.374ZM11.979 16.29a3.645 3.645 0 1 1 7.29 0 3.645 3.645 0 0 1-7.29 0Zm7.655-2.916a1.093 1.093 0 1 0 0-2.187 1.093 1.093 0 0 0 0 2.187Z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "instagramRegularPaint0",
			x1: 1.6,
			x2: 31.4,
			y1: 2.6,
			y2: 31.4,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#F48952" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#EE3178"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9B29B1"
				})
			]
		}) })
	]
});
export default SvgInstagramRegularIcon;
